import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import isEqual from 'fast-deep-equal';
import { PubSub } from './PubSub.js';
import { StoreOverloaded } from './StoreOverloaded.js';
/** Values reported by the application. Overrides live in `StoreOverloaded`, backed by localStorage. */ var Store = {
    privilegesTool: {},
    launchDarklyTool: {},
    trackingTool: []
};
/**
 * Debug state in two layers: the values reported by the application, and the overrides set from the
 * debug bar, which take precedence.
 *
 * Every method short-circuits when the debug bar is disabled at build time.
 */ export var Debug = {
    /** Returns the value reported by the application, ignoring any override. */ getBaseState: function getBaseState(key) {
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return undefined;
        }
        return Store[key];
    },
    /** Returns the effective value: the override when one is set, the application value otherwise. */ getState: function getState(key) {
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return undefined;
        }
        var storeOverloadedByKey = StoreOverloaded.getByKey(key);
        return storeOverloadedByKey !== undefined ? storeOverloadedByKey : Store[key];
    },
    /** Whether an override is set and differs from the value reported by the application. */ isOverloaded: function isOverloaded(key) {
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return false;
        }
        return StoreOverloaded.isKeyActive(Store, key);
    },
    /** Drops the override of a key, back to the value reported by the application, and notifies subscribers. */ resetState: function resetState(key) {
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return;
        }
        StoreOverloaded.resetByKey(key);
        PubSub.publish(key);
    },
    /**
     * Applies `setter` to a key. With `overloaded`, it writes an override seeded from the current
     * application value; otherwise it writes the application value itself.
     * Subscribers are notified only when the write changed something.
     */ setState: function setState(key, setter) {
        var overloaded = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (__USE_DEBUG_BAR__ !== 'true') {
            StoreOverloaded.reset();
            return;
        }
        var after;
        var before;
        if (!overloaded) {
            before = Store;
            Store = _object_spread_props(_object_spread({}, Store), _define_property({}, key, setter(Store[key])));
            after = Store;
        } else {
            var storeOverloaded = StoreOverloaded.get();
            before = storeOverloaded;
            after = _object_spread_props(_object_spread({}, storeOverloaded), _define_property({}, key, setter(storeOverloaded[key] || Store[key])));
            StoreOverloaded.set(after);
        }
        if (!isEqual(before, after)) {
            PubSub.publish(key);
        }
    }
};

//# sourceMappingURL=Debug.js.map